export default "__VITE_ASSET__B7n0cst$__"